import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { H1 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface HeroTextModuleProps {
  heading: string;
  background: Gcms_Asset;
}

interface StyledContainerProps {
  right?: boolean;
}

const StyledContainer = styled(Container)<StyledContainerProps>`
  display: flex;
  justify-content: ${({ right }) => (right ? 'flex-end' : 'flex-start')};
  padding: 11rem 0 12rem;

  ${theme.mediaQueries.tablet} {
    padding: 5rem 0 9rem;
  }

  ${theme.mediaQueries.mobileAndTablet} {
    padding: 8rem 0 3.75rem;
  }
`;

const StyledH1 = styled(H1)`
  font-family: ${theme.typography.primaryFont.light};
  color: ${theme.colors.white};
  font-size: 4rem;
`;

function HeroTextModule({ heading, background }: HeroTextModuleProps) {
  return (
    <StyledContainer background={background}>
      <StyledH1>{heading}</StyledH1>
    </StyledContainer>
  );
}

export default React.memo(HeroTextModule);
